"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _slice = require("@lce/slice/");

var _Mobile = _interopRequireDefault(require("./Mobile"));

var _Desktop = _interopRequireDefault(require("./Desktop"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Header = function Header(_a) {
  var _b = _a.hideAccount,
      hideAccount = _b === void 0 ? false : _b,
      _c = _a.hideCart,
      hideCart = _c === void 0 ? false : _c,
      _d = _a.isStickyHeader,
      isStickyHeader = _d === void 0 ? true : _d;
  return _react["default"].createElement(_slice.Box, {
    as: "header"
  }, _react["default"].createElement(_Mobile["default"], {
    hideAccount: hideAccount,
    hideCart: hideCart,
    isSticky: isStickyHeader
  }), _react["default"].createElement(_Desktop["default"], {
    hideAccount: hideAccount,
    hideCart: hideCart
  }));
};

var _default = Header;
exports["default"] = _default;